<template>
  <modal
    :show.sync="isActiveLocal"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-medi-popup cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
  >
    <div class="flex justify-between pt-4 pb-8 lg:px-4 md:px-4 px-2">
      <div class="my-auto">
        <p class="font-semibold text-2xl col-black">
          Become a Service Provider
        </p>
      </div>
      <img
        src="../../../assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLocal = false"
      />
    </div>

    <div class="lg:px-4 md:px-4 px-2">
      <div>
        <div>
          <div v-if="pageCount === 1">
            <div class="mt-4">
              <p class="col-black font-semibold">First Name</p>
              <b-input
                placeholder="First Name"
                class="form-control-muted mb-4"
                v-model="user.firstname"
                :disabled="true"
              />
              <p class="col-black font-semibold">Last Name</p>
              <b-input
                placeholder="Last Name"
                class="form-control-muted mb-4"
                v-model="user.lastname"
                :disabled="true"
              />

              <p class="col-black font-semibold">Date of Birth</p>
              <base-input
                type="date"
                value="DOB"
                id="example-date-input"
                class="form-control-muted mb-4"
                placeholder="Enter Date of birth"
                v-model="dob"
                :max="maxDate"
              />
              <!-- :disabled-date="disableDate" -->
              <p class="col-black font-semibold">Gender</p>

              <el-select
                placeholder="gender"
                v-model="gender"
                class="w-full custselect"
              >
                <el-option label="Male" value="Male"></el-option>
                <el-option label="Female" value="Female"></el-option>
                <!-- <el-option>Male</el-option> -->
                <!-- <el-option>Female</el-option> -->
              </el-select>
            </div>
          </div>
          <div v-if="pageCount === 2">
            <!-- <feather-icon
              icon="ChevronLeftIcon"
              class="cursor-pointer"
              @click="isshowform = false"
            /> -->
            <div class="w-full">
              <p class="col-black font-semibold">
                Location<span class="clr-red">*</span>
              </p>
              <b-form-select
                v-model="location"
                :options="platformOptions"
                class="mb-3"
                value-field="item"
                text-field="name"
              >
              </b-form-select>
            </div>
            <div class="w-full">
              <p class="col-black font-semibold">
                Service Type<span class="clr-red">*</span>
              </p>
              <b-form-select
                v-model="serviceType"
                :options="serviceTypeOptions"
                class="mb-3"
                value-field="item"
                text-field="name"
              >
              </b-form-select>
            </div>
            <div class="w-full">
              <p class="col-black font-semibold">
                Services<span class="clr-red">*</span>
              </p>
              <b-form-select
                v-model="service"
                :options="services"
                class="mb-3"
                value-field="item"
                text-field="name"
              >
              </b-form-select>
            </div>
            <div class="w-full">
              <p class="col-black font-semibold">
                Type<span class="clr-red">*</span>
              </p>
              <b-form-select
                v-model="type"
                :options="typeOptions"
                class="mb-3"
                value-field="item"
                text-field="name"
              >
              </b-form-select>
            </div>
            <p class="col-black font-semibold">Experience</p>
            <b-input
              placeholder="Experience in months"
              class="form-control-muted mb-4"
              v-model="experience"
            />
            <p class="col-black font-semibold">Expertise</p>
            <b-input
              placeholder="Enter Expertise"
              class="form-control-muted mb-4"
              v-model="expertise"
            />
            <p class="col-black font-semibold">Social Media</p>
            <b-input
              placeholder="Social Media Link"
              class="form-control-muted mb-4"
              v-model="social"
            />
          </div>
          <div v-if="pageCount === 3">
            <p class="col-black font-semibold">Price</p>
            <b-input
              placeholder="Enter Service Amount"
              class="form-control-muted mb-4"
              v-model="price"
            />
            <p class="col-black font-semibold">Bank Name</p>
            <b-input
              placeholder="Enter Bank Name"
              class="form-control-muted mb-4"
              v-model="bankName"
            />
            <p class="col-black font-semibold">Account Number</p>
            <base-input
              placeholder="Enter Account Number"
              class="form-control-muted mb-4"
              v-model="accountNumber"
              name="Account Number"
              :rules="{ regex: '^[0-9]{9,18}$' }"
            />
            <p class="col-black font-semibold">IFSC Code</p>
            <base-input
              placeholder="Enter IFSC Code"
              class="form-control-muted mb-4"
              v-model="IFSCCode"
              name="IFSC Code"
              :rules="{ regex: '^[A-Z]{4}0[A-Z0-9]{6}$' }"
            />
          </div>
          <div class="text-center">
            <b-button
              variant="primary"
              class="mr-4 mt-4"
              v-if="pageCount > 1"
              @click="DecCount()"
              >Previous</b-button
            >
            <template v-if="pageCount == 1">
              <b-button variant="primary" class="mr-4 mt-4" @click="IncCount()"
                >Next</b-button
              >
            </template>
            <template v-if="pageCount > 1 && pageCount !== totalPage">
              <b-button
                variant="primary"
                class="mr-4 mt-4"
                @click="IncCount()"
                :disabled="
                  location == '' ||
                  serviceType == '' ||
                  service == '' ||
                  type == ''
                "
                >Next</b-button
              >
            </template>
            <b-button
              variant="primary"
              class="mr-4 mt-4"
              :disabled="
                location == '' ||
                serviceType == '' ||
                service == '' ||
                type == ''
              "
              v-if="pageCount === totalPage"
              @click="handleSubmit"
              >Submit</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <template slot="footer"> <div class="hidden"></div> </template>
  </modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
export default {
  components: {
    DatePicker,
    Multiselect,
  },
  data() {
    return {
      isshowform: false,
      flex: "",
      experience: "",
      value: "",
      pageCount: 1,
      totalPage: 2,
      platform: [],
      platformOptions: [
        // "west mumbai",
        // "east mumbai",
        // "north mumbai",
        // "south mumbai",
        // "chandivali",
      ],
      dob: "",
      gender: "",
      expertise: "",
      price: "",
      social: "",
      adminapprove: "false",
      location: "",
      service: "",
      services: [
        // "Caregiver Coaching",
        // "Family Counseling",
        // "Caregiver counseling and therapy",
        // "Care Assistance",
        // "Will an inheritance",
      ],
      serviceType: "",
      serviceTypeOptions: ["Volunteer", "Service Provider"],
      type: "",
      typeOptions: ["Individual", "Company"],
      bankName: "",
      accountNumber: "",
      IFSCCode: "",
      maxDate: null,
    };
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedvolunteer: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    get_all_location_name() {
      // console.log("running");
      // console.log(this.get_all_location_name);
      // console.log(this.isActive);
      this.init();
    },
    serviceType(val) {
      // console.log(val);
      if (val === "Service Provider") {
        this.totalPage = 3;
      } else {
        this.totalPage = 2;
        this.price = "";
        this.bankName = "";
        this.accountNumber = "";
        this.IFSCCode = "";
      }
    },
  },
  computed: {
    isActiveLocal: {
      get() {
        // console.log(this.isActive);
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
    ...mapState("auth", { user: "user" }),
    ...mapState("eLearning", {
      profileData: "profileData",
    }),
    ...mapState("respitecare", {
      get_all_location_name: "get_all_location_name",
    }),
    ...mapState("services", { get_AllService: "get_AllService" }),
  },
  methods: {
    IncCount() {
      this.pageCount++;
    },
    DecCount() {
      if (this.pageCount > 1) {
        this.pageCount--;
      }
    },
    closeModal() {
      this.$emit("close");
    },
    resetForm() {
      this.dob = "";
      this.gender = "";
      this.expertise = "";
      this.experience = "";
      this.price = "";
      this.social = "";
      this.location = "";
      this.service = "";
      this.serviceType = "";
      this.bankName = "";
      this.accountNumber = "";
      this.IFSCCode = "";
      this.type = "";
      this.pageCount = 1;
      this.totalPage = 2;
    },
    disableDate(date) {
      // if (this.dob) {
      let newDate = new Date(date);
      return newDate < date;
      // }
    },
    async init() {
      this.platformOptions = this.get_all_location_name.map(
        (locationName) => locationName
      );
      // console.log(this.platformOptions);
      // this.resetForm();
    },
    async adminapprovecheck() {
      if (this.user && this.user._id) {
        let data2 = await this.$store.dispatch(
          "respitecare/get_volunteerbyuserid",
          {
            volunteerId: this.user._id,
            isReq: 1,
          }
        );
        await this.$store.dispatch("respitecare/get_all_location_name");
        if (data2 == null) {
          this.flex = 1;
          // console.log(this.flex);
          return flex;
        } else {
          this.flex = 0;
          // console.log(this.flex);
          // return flex;
        }
      }
    },
    async handleSubmit() {
      let payload = {
        gender: this.gender,
        DOB: this.dob,
        socialMedia: this.social,
        price: this.price,
        location: this.location,
        bankName: this.bankName,
        serviceType: this.serviceType,
        service: this.service,
        accountNumber: this.accountNumber,
        IFSCCode: this.IFSCCode,
        expertise: this.expertise,
        experience: this.experience,
        type: this.type,
        isAdminApprove: this.adminapprove,
      };
      try {
        const data = await this.$store.dispatch(
          "respitecare/createvolunteer",
          payload
        );

        const emailPayload = {
          userEmail: this.user.email,
        };
        const becomevolEmail = await this.$store.dispatch(
          "respitecare/email_becomevol",
          emailPayload
        );
        this.closeModal();
        this.resetForm();
        this.$swal.fire({
          text: "Added Successfully",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        payload = {};
      } catch (error) {
        // console.log(error.response);
        if (error.response.status == 400) {
          this.$swal.fire({
            // title: "Bad Request",
            text: error.response.data.message,
            icon: "info",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        } else if (error) this.$swal("", "Something went wrong", "error");
      }
    },
  },
  async mounted() {
    this.resetForm();
    if (this.experience) {
      this.experience = this.profileData[0].experience;
    }
    await this.$store.dispatch("services/get_all");
    this.get_AllService.result.forEach((ele) => {
      this.services.push(ele.title);
    });
    this.adminapprovecheck();
    await this.init();
    const today = new Date().toISOString().split("T")[0];
    this.maxDate = today;
  },
};
</script>
<style scoped>
.bg-multi {
  background-color: #f7fafe !important;
  border-color: #f7fafe !important;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.displaynone {
  display: none;
}
.custselect.el-select-dropdown__item.selected {
  color: #606060;
}
</style>
